/**
 * Integrytas Group - Unified Notification Engine (UNE)
 * useActiveWorkspace - the active-workspace context. The selected workspace
 * scopes notifications, logs, and preference/rule evaluation. Persisted in
 * localStorage; defaults to the system default workspace.
 */

import { useCallback, useEffect, useState } from 'react';
import { apiDb } from './api_client';

export interface UneWorkspace { une_workspace_id: number; internal_code: string; name: string; is_default: 'Y' | 'N' }

const KEY = 'une.active_workspace';

export function useActiveWorkspace(): { workspaces: UneWorkspace[]; activeCode: string; activeId: number | null; setActive: (code: string) => void; loading: boolean } {
  const [workspaces, setWorkspaces] = useState<UneWorkspace[]>([]);
  const [activeCode, setActiveCode] = useState<string>(() => localStorage.getItem(KEY) ?? '');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void apiDb.from('une_workspace').select('une_workspace_id, internal_code, name, is_default').eq('is_active', 'Y').order('name')
      .then(({ data }) => {
        if (cancelled) return;
        const ws = (data ?? []) as UneWorkspace[];
        setWorkspaces(ws);
        setActiveCode(prev => prev || ws.find(w => w.is_default === 'Y')?.internal_code || ws[0]?.internal_code || '');
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const setActive = useCallback((code: string) => { setActiveCode(code); localStorage.setItem(KEY, code); }, []);
  const activeId = workspaces.find(w => w.internal_code === activeCode)?.une_workspace_id ?? null;
  return { workspaces, activeCode, activeId, setActive, loading };
}
